import moment from "moment";
import { Button, Card, Form, Modal } from "react-bootstrap";
import displayGlobalMessage, { toastConfig } from "Utils/DisplayGlobalMessage";
import { toast } from "react-toastify";
import { useEffect } from "react";
import * as constants from "Constants";
import httpService from "services/httpService";
import log from "loglevel";

const StudentFiles = ({
    otherActivityData,
    showStudentFilesModal,
    handleOpenStudentFilesModal,
    handleCloseStudentFilesModal,
    studentFiles,
    setStudentFiles,
    isDisabled,
    student_email,
    student_name
}) => {

    const downloadFile = async (file) => {
        try {
            let url = file?.required_file;
            // if (url) {
            //   url = url.replace('http://', 'https://');
            // }

            const response = await fetch(url);
            if (!response.ok) {
                displayGlobalMessage(`Error: ${response.statusText}`, 'error');
                return;
            }
            const blob = await response.blob(); // Get the file as a Blob object
            const urlObject = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = urlObject;
            const filename = file?.required_file_name || url.split('/').pop(); // Use the provided filename or extract it from the URL
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            displayGlobalMessage(`${filename} is being downloaded`, 'success');
            window.URL.revokeObjectURL(urlObject);
            document.body.removeChild(a);
        } catch (error) {
            log.error('Failed to download file:', error);
            displayGlobalMessage('Failed to download file', 'error');
        }
    }

    const removeAFileFromStudentFiles = (fileObj) => {

        const deleteUploadStudentsFile = async (fileObj) => {
            let _url = constants.base_url + "/otherlabs/activity/";
            log.log({ fileObj });
            let deleteFileUrl = _url + otherActivityData?.id + "/other_submission_files/?required_file_id=" + (fileObj?.required_file_id || fileObj.id);
            let toastId = "";
            try {
                toastId = toast.loading(
                    `Deleting ${(fileObj.name || fileObj?.required_file_name)}`,
                    {
                        position: "bottom-right",
                        autoClose: false,
                        closeOnClick: false,
                        draggable: false,
                        hideProgressBar: true,
                    }
                );
                const response = await httpService.delete(deleteFileUrl);
                log.log(response.data);
                if (response.status >= 200 && response.status <= 300) {
                    toast.update(toastId, {
                        render: `Deleted ${(fileObj.name || fileObj?.required_file_name)}`,
                        type: "success",
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                        hideProgressBar: false,
                        isLoading: false
                    });
                    setStudentFiles(files => {
                        let _files = files.filter(f => {
                            let filename = (fileObj.name || fileObj.required_file_name);
                            let alreadyPresentFileName = (f.name || f.required_file_name);
                            log.log({ filename, alreadyPresentFileName })
                            return filename !== alreadyPresentFileName;
                        });
                        let _files_ = JSON.parse(JSON.stringify(_files));
                        return _files_;
                    });
                }
            } catch (err) {
                log.error(err);
                toast.update(toastId, {
                    render: `Couldn't delete ${(fileObj.name || fileObj?.required_file_name)}. 
                Request Failed ${err?.response?.status ? `with status code: ${err?.response?.status}` : ''}`,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    draggable: true,
                    hideProgressBar: false,
                    isLoading: false
                })
                return;
            }
        }

        deleteUploadStudentsFile(fileObj);
    }

    const addStudentFiles = (files) => {
        // log.log(files, files instanceof FileList, typeof files);

        if (files instanceof FileList) {
            let fileObjects = [];
            let totalFilesRequired = otherActivityData?.required_files_num;

            let filesGiven = files.length;
            let filesPresent = studentFiles?.length;

            let total_files = filesGiven + filesPresent;

            if (total_files > totalFilesRequired) {
                displayGlobalMessage(`Total files cannot be more than ${otherActivityData?.required_files_num}.`, "error");
                return;
            }

            for (let i = 0; i < filesGiven; i++) {
                let file = files[i];
                let alreadyExistingFileIndex = studentFiles?.findIndex(f => f.name === file.name);
                if (alreadyExistingFileIndex !== -1) {
                    displayGlobalMessage(`${file.name} is already uploaded.`, 'error');
                    return;
                }
                let fileObj = {
                    fileObj: file,
                    name: file.name,
                    timestamp: new Date(),
                    isUploaded: false,
                }
                fileObjects.push(fileObj);
            }

            let requiredFileNames = otherActivityData?.required_files_name;
            let filesToAppend = [];

            if (requiredFileNames === "any") {
                // no checking required
                for (let file of fileObjects) {
                    const fileSizeInMB = file.fileObj.size / (1024 * 1024);
                    if (fileSizeInMB > 10) {
                        displayGlobalMessage(`File size cannot be more than 10MB`, "error");
                        return;
                    }
                    filesToAppend.push(file);
                }
            } else {
                requiredFileNames = requiredFileNames?.split?.(" ");

                if (requiredFileNames.length === totalFilesRequired) {
                    let unAddedFiles = []
                    for (let fileName of requiredFileNames) {
                        let split_file_name = fileName?.split?.(".");
                        let name = split_file_name[0];
                        let extension = split_file_name[1];

                        const regex = new RegExp(extension.replace('.', '\\.') + '$');
                        let requiredFileInFileObjects = "";
                        let requiredFileInStudentFiles = "";

                        if (name === "*") {
                            requiredFileInFileObjects = fileObjects.find(f => regex.test(f.name));
                            requiredFileInStudentFiles = studentFiles.find(f => regex.test(f.name));
                        } else {
                            requiredFileInFileObjects = fileObjects.find(f => f.name === fileName);
                            requiredFileInStudentFiles = studentFiles.find(f => f.name === fileName);
                        }

                        if (requiredFileInFileObjects && !requiredFileInStudentFiles) {
                            const fileSizeInMB = requiredFileInFileObjects.fileObj.size / (1024 * 1024);
                            log.log({ fileSizeInMB, size: requiredFileInFileObjects.fileObj.size });
                            if (fileSizeInMB > 10) {
                                displayGlobalMessage(`File size cannot be more than 10MB`, "error");
                                return;
                            }
                            filesToAppend.push(requiredFileInFileObjects);
                            displayGlobalMessage(`${fileName} added.`, "info");
                        } else {
                            if (requiredFileInStudentFiles) {
                                // already added
                            } else {
                                unAddedFiles.push(fileName);
                            }
                        }
                    }
                    if (unAddedFiles.length > 0) {
                        let message = <span>Remaining files with the names: {unAddedFiles.map(f => <pre style={{ display: "inline" }}>{f + " "}</pre>)}</span>
                        displayGlobalMessage(message, "info");
                    }
                } else {
                    // this should not happen
                    displayGlobalMessage("Filenames provided are incorrect. The count does not match with the count required. Please contact your instructor to remove unnecessary blank spaces between the files names.", "error");
                    return;
                }
            }

            setStudentFiles((files) => {
                let newFiles = (files || []).concat(filesToAppend);
                log.log({ newFiles });
                return newFiles;
            });

        } else {

        }
    }

    useEffect(() => {
        log.log({ studentFiles });

        const uploadStudentsFile = async (fileObj) => {

            if (otherActivityData?.required_files_num > 0 && studentFiles.length > 0) {
                let filename = fileObj.name;
                let isUploaded = studentFiles.filter(r => r.name === filename).filter(r => r.isUploaded);
                if (isUploaded.length > 0 || !(fileObj.fileObj instanceof File)) {
                    log.log("Already Uploaded")
                    return;
                }
                let otherActivityFiles = new FormData();
                otherActivityFiles.append('studentFiles', fileObj.fileObj);
                let _url = constants.base_url + "/otherlabs/activity/";
                let saveFilesUrl = _url + otherActivityData?.id + "/other_submission_files/?stud_id=" + encodeURIComponent(student_email) + "&username=" + encodeURIComponent(student_name);
                let toastId = "";
                let toastText = `Uploading ${(fileObj.name || fileObj?.required_file_name)}`;
                try {
                    toastId = toast.loading(
                        toastText,
                        {
                            position: toastConfig.position,
                            autoClose: false,
                            closeOnClick: false,
                            draggable: false,
                            hideProgressBar: true,
                        }
                    );
                    const response = await httpService.post(saveFilesUrl, otherActivityFiles);
                    log.log(response.data);
                    toast.update(toastId, {
                        render: `Uploaded ${(fileObj.name || fileObj?.required_file_name)}`,
                        type: "success",
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                        hideProgressBar: false,
                        isLoading: false
                    });
                    setStudentFiles(files => {
                        let index = files.findIndex(f => f.name === (fileObj.name || fileObj?.required_file_name));
                        if (index !== -1) {
                            files[index].isUploaded = true;
                            files[index]['required_file_id'] = response.data?.id;
                            files[index]['required_file'] = response.data?.file?.required_file;
                        }
                        log.log({ files });
                        let _files = JSON.parse(JSON.stringify(files));
                        return _files;
                    });
                } catch (err) {
                    log.error(err);
                    toast.update(toastId, {
                        render: `Couldn't upload ${(fileObj.name || fileObj?.required_file_name)}. Request Failed`,
                        type: "error",
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                        hideProgressBar: false,
                        isLoading: false
                    })
                    return;
                }
            }
        }

        const assesAndUploadStudentFiles = async (notUploadedFiles) => {

            for (const unUploadedFile of notUploadedFiles) {

                await uploadStudentsFile(unUploadedFile);
            }

            if (otherActivityData?.required_files_num === studentFiles.length) {
                handleCloseStudentFilesModal();
            }

        }

        let notUploadedFiles = studentFiles?.filter?.(f => !f.isUploaded);
        log.log({ notUploadedFiles });

        if (notUploadedFiles?.length > 0) {
            assesAndUploadStudentFiles(notUploadedFiles);
        }

    }, [studentFiles]);

    return (<>

        <Card className="text-start" style={{ marginLeft: "10px", marginRight: "10px", marginTop: "20px", padding: "10px", border: "1px solid #ddd" }}>
            <Card.Body>
                <p className="d-flex align-items-center gap-3">
                    <span>
                        <b>No. of files:</b> {otherActivityData?.required_files_num}
                    </span>
                    <span>
                        <b>Required files:</b> {otherActivityData?.required_files_name}
                    </span>
                </p>
                {!isDisabled ?
                    <Button disabled={otherActivityData?.required_files_num === studentFiles.length} onClick={handleOpenStudentFilesModal}>
                        Submit Files
                    </Button>
                    : <></>
                }
                {
                    studentFiles?.filter(f => (f.isUploaded || f.id))?.length > 0 ? <>
                        <Card className="background-white" style={{ marginTop: 10, padding: "10px", border: "1px solid #ddd" }}>
                            <Card.Title>Submitted Files:</Card.Title>
                            <Card.Body>
                                <table border={1}>
                                    <tbody>
                                        <tr>
                                            <td><b>Filename</b></td>
                                            <td><b>Timestamp</b></td>
                                            <td><b>Delete</b></td>
                                        </tr>
                                        {
                                            studentFiles?.filter(f => (f.isUploaded || f.id))?.map?.((file, index) => {
                                                return <tr key={index}>
                                                    <td>{(file?.name || file?.required_file_name)}</td>
                                                    <td>{moment(file?.timestamp).format('ddd MMM DD YYYY HH:mm:ss')}</td>
                                                    <td>
                                                        <div className="d-flex flex-column gap-2">
                                                            {
                                                                !isDisabled && <Button disabled={isDisabled} variant="danger" size="sm" onClick={() => removeAFileFromStudentFiles(file)}>
                                                                    Delete File
                                                                </Button>
                                                            }
                                                            {
                                                                file?.required_file && <Button variant="primary" size="sm" onClick={() => downloadFile(file)}>
                                                                    Download
                                                                </Button>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </> : <>
                        {
                            isDisabled && <Card className="background-white" style={{ marginTop: 10, padding: "10px", border: "1px solid #ddd" }}>
                                No files Submitted
                            </Card>
                        }
                    </>
                }
            </Card.Body>
        </Card>

        <Modal
            show={showStudentFilesModal}
            onHide={handleCloseStudentFilesModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Additional Files</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Please upload files required for lab submission.</p>
                <Form.Group className="py-1">
                    <Form.Control size="sm" multiple type="file" name="additional_files" onChange={(e) => addStudentFiles(e.target.files)} />
                </Form.Group>
                <p>Only required files will be uploaded.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseStudentFilesModal}>Close</Button>
            </Modal.Footer>
        </Modal>
    </>);
}

export default StudentFiles;